import { VOAsset, IData } from "./DataStructure.js";

export class Assets {
    private static _data: IData;
    public static init(data: IData): void {
        this._data = data;
    }

    public static getAsset(title: string): VOAsset {
        for (var asset of Assets._data.asset) {
            if (asset.title === title)
                return asset;
        }
        return null;
    }

    public static getUrl(title: string, fallback: string = ""): string {
        var asset = Assets.getAsset(title);
        if (asset && asset.media)
            return asset.media.url;
        return fallback;
    }
}